<template>
  <div class="config">
    <el-form class="select-panel-form" :inline="true" ref="form" :model="selectForm" label-width="80px">
      <div>
        <el-form-item>
          <el-select v-model="panelId" placeholder="请选择面板" size="mini" filterable clearable @change="changePanel" @clear="addPanel">
            <el-option v-for="item in panelOptions" :key="item.panelId" :label="item.panelName" :value="item.panelId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item><el-button type="primary" size="mini" @click="addPanel">新增面板</el-button></el-form-item>
        <el-form-item><el-button type="primary" size="mini" class="button-width" @click="publish">发布</el-button></el-form-item>
      </div>
    </el-form>
    <div class="panel-form">
      <el-form v-for="(form, index) in paramDTOS" :key="index" :inline="true" ref="form" :model="form" label-width="80px">
        <div class="row" v-if="index === 0">
          <el-form-item><el-input placeholder="请输入面板名称" v-model="panelName" size="mini" class="select-width"></el-input></el-form-item>
        </div>
        <div class="block-config">
          <div class="row">
            <el-form-item>
              <el-select :value="form.type" placeholder="请选择母版" size="mini" class="select-width" @change="res => changeMother(res, index)">
                <el-option v-for="item in motherboadrOptions" :key="item.type" :label="item.label" :value="item.type"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item><el-button @click="addMotherBoadr(index)" type="primary" size="mini" icon="el-icon-plus" circle></el-button></el-form-item>
            <el-form-item v-if="index > 0"><el-button type="danger" size="mini" icon="el-icon-minus" circle @click="deleteMotherBoadr(index)"></el-button></el-form-item>
          </div>
          <div class="s1" v-if="form.type == 1">
            <div class="row">
              <div v-for="(item, formIndex) in form.formObjects" :key="formIndex">
                <el-form-item><el-input placeholder="表单字段中文名称" size="mini" v-model="item.name" clearable></el-input></el-form-item>
                <el-form-item><el-input placeholder="占位编号" size="mini" v-model="item.placeholder" disabled></el-input></el-form-item>
                <el-form-item><el-input placeholder="单位" size="mini" v-model="item.unit" clearable></el-input></el-form-item>
                <el-form-item>
                  <el-button type="primary" size="mini" icon="el-icon-plus" circle @click="addFormData(index)"></el-button>
                  <el-button v-if="formIndex > 0" type="danger" size="mini" icon="el-icon-minus" circle @click="delFormData(index, formIndex)"></el-button>
                  <!-- <el-button type="primary" size="mini" circle @click="addStatusMap(index, formIndex)">数</el-button> -->
                </el-form-item>
                <div class="row" v-if="item.hasOwnProperty('statusMap')">
                  <div class="title">数字量状态列表</div>
                  <div>
                    <el-table :data="item.statusMap" style="width: 100%">
                      <el-table-column fixed prop="number" label="信息量数字" width="200">
                        <template slot-scope="scope">
                          <el-input v-model="scope.row.number" placeholder="请输入信息量数字" disabled></el-input>
                        </template>
                      </el-table-column>
                      <el-table-column prop="name" label="显示中文">
                        <template slot-scope="scope">
                          <el-input v-model="scope.row.name" placeholder="请输入中文名称"></el-input>
                        </template>
                      </el-table-column>
                      <el-table-column prop="color" label="颜色" width="180">
                        <template slot-scope="scope">
                          <el-input v-model="scope.row.color" placeholder="请输入颜色值"></el-input>
                        </template>
                      </el-table-column>
                      <el-table-column fixed="right" label="操作" width="180">
                        <template slot-scope="scope">
                          <el-button type="text" size="small" icon="el-icon-plus" circle @click="addTableData(index, formIndex)"></el-button>
                          <el-button type="text" size="small" icon="el-icon-minus" circle @click="delTableData(index, formIndex, scope.$index)"></el-button>
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="s2" v-if="form.type == 2">
            <div class="row" v-for="(item, formIndex) in form.listObjects" :key="formIndex">
              <div>
                <el-form-item><el-input v-model="headerTitle" placeholder="列头名称" size="mini" class="input-width" disabled></el-input></el-form-item>
                <el-form-item v-for="(title, colIndex) in item.titles" :key="colIndex">
                  <el-input v-model="item.titles[colIndex]" placeholder="列头名称" size="mini" class="input-width"></el-input>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" size="mini" icon="el-icon-plus" circle @click="addCol(index, formIndex)"></el-button>
                  <el-button type="danger" size="mini" icon="el-icon-minus" circle @click="delCol(index, formIndex)"></el-button>
                  <el-button type="primary" size="mini" circle @click="addGroup(index, formIndex)">组</el-button>
                </el-form-item>
              </div>
              <div v-for="(row, rowIndex) in item.columns" :key="rowIndex">
                <el-form-item>
                  <el-input :disabled="item.titles.length < 1" placeholder="行头名称" size="mini" class="input-width" v-model="item.columns[rowIndex].key"></el-input>
                </el-form-item>
                <el-form-item v-for="(bit, bitIndex) in item.titles" :key="bitIndex">
                  <el-input placeholder="占位编号" v-model="item.columns[rowIndex]['val'][bitIndex]" size="mini" class="input-width" disabled></el-input>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" size="mini" icon="el-icon-plus" circle @click="addRow(index, formIndex)"></el-button>
                  <el-button type="danger" size="mini" icon="el-icon-minus" circle @click="delRow(index, formIndex, rowIndex)"></el-button>
                </el-form-item>
              </div>
            </div>
          </div>
          <div class="s3" v-if="form.type == 3">
            <div class="row">
              <div v-for="(item, formIndex) in form.picObjects" :key="formIndex">
                <el-form-item><el-input placeholder="表单字段中文名称" size="mini" v-model="item.name" clearable></el-input></el-form-item>
                <el-form-item><el-input placeholder="占位编号" size="mini" v-model="item.placeholder" clearable disabled></el-input></el-form-item>
                <el-form-item><el-input placeholder="单位" size="mini" v-model="item.unit" clearable></el-input></el-form-item>
                <el-form-item>
                  <el-button type="primary" size="mini" icon="el-icon-plus" circle @click="addFormData(index)"></el-button>
                  <el-button v-if="formIndex > 0" type="danger" size="mini" icon="el-icon-minus" circle @click="delFormData(index, formIndex)"></el-button>
                  <el-button type="primary" size="mini" circle @click="addStatusMap(index, formIndex)">数</el-button>
                </el-form-item>
                <div class="row" v-if="item.hasOwnProperty('statusMap')">
                  <div class="title">数字量状态列表</div>
                  <div>
                    <el-table :data="item.statusMap" style="width: 100%">
                      <el-table-column fixed prop="number" label="信息量数字" width="200">
                        <template slot-scope="scope">
                          <el-input v-model="scope.row.number" placeholder="请输入信息量数字" disabled></el-input>
                        </template>
                      </el-table-column>
                      <el-table-column prop="name" label="显示中文">
                        <template slot-scope="scope">
                          <el-input v-model="scope.row.name" placeholder="请输入中文名称"></el-input>
                        </template>
                      </el-table-column>
                      <el-table-column prop="color" label="颜色" width="180">
                        <template slot-scope="scope">
                          <el-input v-model="scope.row.color" placeholder="请输入颜色值"></el-input>
                        </template>
                      </el-table-column>
                      <el-table-column fixed="right" label="操作" width="180">
                        <template slot-scope="scope">
                          <el-button type="text" size="small" icon="el-icon-plus" circle @click="addTableData(index, formIndex)"></el-button>
                          <el-button v-if="scope.$index > 0" type="text" size="small" icon="el-icon-minus" circle @click="delTableData(index, formIndex, scope.$index)"></el-button>
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import { getInfo } from '@/utils/auth';
import API from '@/api/glconfig';
export default {
  components: {},
  data() {
    return {
      selectForm: {},
      panelId: '',
      panelName: '',
      paramDTOS: [{ type: 1 }, { type: 2 }, { type: 3 }],
      panelOptions: [],
      motherboadrOptions: [{ type: 1, label: '表单母版' }, { type: 2, label: '列表母版' }, { type: 3, label: '图标母版' }],
      activeName: 'first',
      tableData: [],
      headerTitle: '列头名称',
      listObjects: [
        {
          columns: [{ key: '', val: [] }],
          titles: []
        }
      ]
    };
  },
  watch: {},
  methods: {
    //初始化
    init() {
      this.paramDTOS = [{}];
      this.searchAllSimulationPanelTemplateById();
    },
    //切换面板
    changePanel() {
      API.searchAllSimulationPanelTemplateById().then(res => {
        if (res.data.code == 200) {
          this.panelOptions = res.data.data;
          this.panelOptions.forEach(item => {
            if (item.panelId == this.panelId) {
              this.panelName = item.panelName;
              this.paramDTOS = item.paramDTOS;
            }
          });
          let tmpItem = [];
          this.paramDTOS.forEach((item, key) => {
            var it = { ...item };
            if (item.formObjects) {
              it.type = 1;
              item.formObjects.forEach((item1, index) => {
                if (item1.statusMap) {
                  let statusMap = [];
                  for (var key in item1.statusMap) {
                    item1.statusMap[key].number = key;
                    statusMap.push(item1.statusMap[key]);
                  }
                  it.formObjects[index].statusMap = statusMap;
                }
              });
            }
            if (item.listObjects) {
              it.type = 2;
              item.listObjects.forEach((item, index) => {
                //解析columns
                if (item.columns) {
                  let statusMap = [];
                  for (var key in item.columns) {
                    statusMap.push({ key: key, val: item.columns[key] });
                  }
                  it.listObjects[index].columns = statusMap;
                }
              });
            }
            if (item.picObjects) {
              it.type = 3;
              item.picObjects.forEach((item2, index2) => {
                if (item2.statusMap) {
                  let statusMap = [];
                  for (var key in item2.statusMap) {
                    item2.statusMap[key].number = key;
                    statusMap.push(item2.statusMap[key]);
                  }
                  it.picObjects[index2].statusMap = statusMap;
                }
              });
            }
            tmpItem.push(it);
          });
          this.paramDTOS = tmpItem;
          this.paramDTOS = JSON.parse(JSON.stringify(this.paramDTOS));
          this.sort();
        }
      });
    },
    //新增母版
    addMotherBoadr(index) {
      if (this.paramDTOS.length > 2) {
        this.$message.warning('每个面板最多支持3个母版！');
        return false;
      }
      if (!this.paramDTOS[index].type) {
        this.$message.warning('请选择母版类型！');
        return false;
      }
      this.paramDTOS.push({});
    },
    //删除模板
    deleteMotherBoadr(index) {
      if (this.paramDTOS[index].type) {
        this.$confirm('确认要删除此母版吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.paramDTOS.splice(index, 1);
        });
      } else {
        this.paramDTOS.splice(index, 1);
      }
    },
    //切换母版前的操作
    changeMotherBefore($even, index) {
      if ($even == true) {
        let type = this.paramDTOS[index].type;
      }
    },
    //切换母版
    changeMother(res, index) {
      let type = res;
      this.$confirm('此操作会清空当前数据，是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.paramDTOS[index].type = type;
          if (type == 1) {
            this.paramDTOS[index].formObjects = [{ name: '', placeholder: '', unit: '' }];
          } else if (type == 2) {
            this.paramDTOS[index].listObjects = [{ columns: [{ key: '', val: [] }], titles: [] }];
          } else if (type == 3) {
            this.paramDTOS[index].picObjects = [{ name: '', placeholder: '', unit: '' }];
          }
          this.paramDTOS = JSON.parse(JSON.stringify(this.paramDTOS));
        })
        .catch(() => {});
    },
    //增加表单字段中文名称
    addFormData(index) {
      let type = this.paramDTOS[index].type;
      if (type == 1) {
        this.paramDTOS[index].formObjects.push({ name: '', placeholder: '', unit: '' });
        this.paramDTOS = JSON.parse(JSON.stringify(this.paramDTOS));
      }
      if (type == 3) {
        this.paramDTOS[index].picObjects.push({ name: '', placeholder: '', unit: '' });
        this.paramDTOS = JSON.parse(JSON.stringify(this.paramDTOS));
      }
      this.sort();
    },
    //删除表单字段中文名称
    delFormData(index, formIndex) {
      let type = this.paramDTOS[index].type;
      if (type == 1) {
        this.$confirm('确认要删除吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.paramDTOS[index].formObjects.splice(formIndex, 1);
        });
      }
    },
    //增加数字量状态
    addStatusMap(index, formIndex) {
      let type = this.paramDTOS[index].type;
      if (type == 1) {
        if (this.paramDTOS[index].formObjects[formIndex].statusMap && this.paramDTOS[index].formObjects[formIndex].statusMap.length) {
          this.$message.warning('数字量状态列表已存在！');
          return false;
        } else {
          this.paramDTOS[index].formObjects[formIndex].statusMap = [{ number: '', name: '', color: '' }];
          this.paramDTOS = JSON.parse(JSON.stringify(this.paramDTOS));
        }
      } else if (type == 3) {
        if (this.paramDTOS[index].picObjects[formIndex].statusMap && this.paramDTOS[index].picObjects[formIndex].statusMap.length) {
          this.$message.warning('数字量状态列表已存在！');
          return false;
        } else {
          this.paramDTOS[index].picObjects[formIndex].statusMap = [{ number: '', name: '', color: '' }];
          this.paramDTOS = JSON.parse(JSON.stringify(this.paramDTOS));
        }
      }
      this.sort();
    },
    //添加一行表记录
    addTableData(index, formIndex) {
      let type = this.paramDTOS[index].type;
      if (type == 1) {
        this.paramDTOS[index].formObjects[formIndex].statusMap.push({ number: '', name: '', color: '' });
        this.paramDTOS = JSON.parse(JSON.stringify(this.paramDTOS));
      } else if (type == 3) {
        this.paramDTOS[index].picObjects[formIndex].statusMap.push({ number: '', name: '', color: '' });
        this.paramDTOS = JSON.parse(JSON.stringify(this.paramDTOS));
      }
      this.sort();
    },
    //删除一行表记录
    delTableData(index, formIndex, rowIndex) {
      let type = this.paramDTOS[index].type;
      this.$confirm('确认要删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        if (type == 1) {
          this.paramDTOS[index].formObjects[formIndex].statusMap.splice(rowIndex, 1);
        } else if (type == 3) {
          this.paramDTOS[index].picObjects[formIndex].statusMap.splice(rowIndex, 1);
        }
      });
    },
    //新增面板
    addPanel() {
      if (this.panelId || this.panelName) {
        this.$confirm('是否保存当前编辑面板?', '提示', {
          confirmButtonText: '保存',
          cancelButtonText: '不保存',
          type: 'warning'
        })
          .then(() => {
            this.panelId = '';
            this.panelName = '';
            this.paramDTOS = [{}];
          })
          .catch(() => {
            this.panelId = '';
            this.panelName = '';
            this.paramDTOS = [{}];
          });
      } else {
        this.panelId = '';
        this.panelName = '';
        this.paramDTOS = [{}];
      }
    },
    /* 列表母版*/
    //加列
    addCol(index, formIndex) {
      let val = [];
      this.paramDTOS[index].listObjects[formIndex].titles.push('');
      let titles = this.paramDTOS[index].listObjects[formIndex].titles;
      titles.forEach(item => {
        val.push('');
      });
      this.paramDTOS[index].listObjects[formIndex].columns.map(item=>{
        item.val = val;
      })
      this.sort();
    },
    //删列
    delCol(index, formIndex) {
      let pos = this.paramDTOS[index].listObjects[formIndex].titles.length - 1;
      this.paramDTOS[index].listObjects[formIndex].titles.splice(pos, 1);
    },
    //加行
    addRow(index, formIndex) {
      let val = [];
      let titles = this.paramDTOS[index].listObjects[formIndex].titles;
      titles.forEach(item => {
        val.push('');
      });
      this.paramDTOS[index].listObjects[formIndex].columns.push({ key: '', val: val });
      this.sort();
    },
    //删行
    delRow(index, formIndex, rowIndex) {
      let pos = this.paramDTOS[index].listObjects[formIndex].columns.length - 1;
      if (pos > 0) {
        this.paramDTOS[index].listObjects[formIndex].columns.splice(rowIndex, 1);
      }
    },
    //加组
    addGroup(index, formIndex) {
      this.paramDTOS[index].listObjects.push({
        columns: [{ key: '', val: [] }],
        titles: []
      });
    },
    //数字排序
    sort() {
      let number = 0;
      this.paramDTOS.map(item => {
        let key = '';
        if (item.hasOwnProperty('formObjects')) {
          key = 'formObjects';
        }
        if (item.hasOwnProperty('picObjects')) {
          key = 'picObjects';
        }
        if (item.hasOwnProperty('listObjects')) {
          key = 'listObjects';
        }
        item[key].map(item1 => {
          if (item1.hasOwnProperty('placeholder')) {
            item1.placeholder = number;
            number++;
          }
          if (item1.hasOwnProperty('statusMap') && item1.statusMap != null) {
            item1.statusMap.map(item2 => {
              item2.number = number;
              number++;
            });
          }
          if (item1.hasOwnProperty('columns')) {
            item1.columns.map(item3 => {
              let v = [];
              for (var key in item3.val) {
                v.push(number);
                number++;
              }
              item3.val = v;
            });
          }
        });
      });
      this.paramDTOS = JSON.parse(JSON.stringify(this.paramDTOS));
    },
    //发布面板
    publish() {
      let params = {};
      params.panelId = this.panelId ? this.panelId : 0;
      params.panelName = this.panelName;
      params.paramDTOS = JSON.parse(JSON.stringify(this.paramDTOS));
      if (!params.panelName) {
        this.$message.warning('请输入面板名称！');
        return false;
      }
      params.paramDTOS.map(item => {
        if (item.type == 1) {
          item.formObjects.map(it => {
            if (it.hasOwnProperty('statusMap')) {
              let tmp = {};
              let key = '';
              it.statusMap.forEach(i => {
                key = i.number.toString();
                tmp[key] = { name: i.name, color: i.color };
              });
              it.statusMap = tmp;
            }
          });
        }
        if (item.type == 2) {
          item.listObjects.map(it => {
            if (it.columns.length) {
              let columns = [];
              let tmp = {};
              it.columns.forEach(i => {
                let k = i.key;
                tmp[k] = i.val;
              });
              it.columns = tmp;
            }
          });
        }
        if (item.type == 3) {
          item.picObjects.map(it => {
            if (it.statusMap == null) {
              delete it.statusMap;
            }
            if (it.hasOwnProperty('statusMap')) {
              let tmp3 = {};
              let key = '';
              it.statusMap.forEach(i => {
                key = i.number.toString();
                tmp3[key] = { name: i.name, color: i.color };
              });
              it.statusMap = tmp3;
            }
          });
        }
      });
      API.saveOrUpdateSimulationPanelTemplate(params).then(res => {
        if (res.data.code == 200) {
          // this.panelId = res.data.data;
          this.$message.success('操作成功');
          this.searchAllSimulationPanelTemplateById();
        }
      });
    },
    //获取全部模板
    searchAllSimulationPanelTemplateById() {
      API.searchAllSimulationPanelTemplateById().then(res => {
        if (res.data.code == 200) {
          this.panelOptions = res.data.data;
        }
      });
    },
    handleClick(e) {}
  },
  created() {
    this.init();
  }
};
</script>

<style lang="scss" scoped="scoped">
.config {
  .select-panel-form {
    .button-width {
      width: 90px;
    }
  }
  .panel-form {
    height: 66vh;
    overflow-y: auto;
    .select-width {
      width: 432px;
    }
    .input-width {
      width: 80px;
    }
    .block-config {
      border: 1px solid #dddeee;
      border-radius: 10px;
      padding: 20px;
      margin-bottom: 20px;
      .title {
        margin: 10px 0px;
        font-weight: bold;
      }
      .row {
        margin: 5px 0px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/boss/template/components/config.vue